module.exports = new __parcel__URL__("vibe-3-mobile.532853d7.json").toString();